import { AppointmentsInterface } from './appointments.interface';
import { UsersInterface } from '../users';

export interface AppointmentCommentsInterface {
  id: string;
  content: string;
  appointment: AppointmentsInterface;
  user: UsersInterface;
}
